import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import SensorHandle from '../SensorHandle';
import { SensorTouchNodeType } from '../types';
import BaseNode from '../BaseNode';

export const SensorTouchNode = memo(
  ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    data,
    selected,
    disabled,
  }: {
    data: SensorTouchNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();

    let text = intl.formatMessage({
      defaultMessage: 'Touch Event',
      id: 'IVOIWo',
    });
    if (data.options.language) {
      text += ` | ${data.options.language}`;
    }

    return (
      <BaseNode
        selected={selected ?? false}
        type="sensor"
        isValid={data.isValid}
        disabled={disabled ?? false}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Touch',
              id: 'lDEhUP',
            })}
          </T>
          <T body2>{text}</T>
        </Flex>
        <SensorHandle id="active" posTop="50%" disabled={disabled} />
      </BaseNode>
    );
  },
);
